// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"navigation_wrapper__2TEOZ","link":"navigation_link__1mqGZ","active":"navigation_active__3_qnU"};